import React, { useState } from "react";
import { QRCode, Space } from 'antd';
import { useParams } from "react-router-dom";

function Payment() {
    const params = useParams();
    const [text, setText] = useState('https://ant.design/');
    return (
        <div className='container mx-auto h-screen flex justify-center items-center'>
            <div className="border-[2px] border-light rounded-xl p-6 w-full">
                <h2 className="text-[#2F2B3D] text-xl font-semibold text-center whitespace-nowrap">
                    You can make the payment by using the address given below or by scanning the QR code
                </h2>
                <Space direction="vertical" align="center">
                    <QRCode value={params?.id || '-'} />
                </Space>
               
                    <div className="flex flex-col mt-4">
                        <div className="flex mt-4 items-center">
                            <h3 className="font-semibold min-w-[120px]">Address to Pay:</h3>
                            {/* <p className="ml-6">TX2i3T31yrtE6KFLiPrDUgKFUEpzkbXXJc</p> */}
                            <p className="ml-6">{params?.id || "-"}</p>
                        </div>

                        <div className="flex mt-4 items-center">
                            <h3 className="font-semibold min-w-[120px]">Price (USD):</h3>
                            <p className="ml-6">14 USD (12 USD Requested Amount and 2 USD Transaction Charge)</p>
                        </div>

                        <div className="flex mt-2">
                            <p className="text-sm">Note: Please double-check that we get the full amount shown below. Some wallets take out a fee from the amount sent, which can cause us to receive less.</p>
                        </div>

                        <div className="flex mt-4 items-center">
                            <h3 className="font-semibold min-w-[120px]">Amount to Pay:</h3>
                            <h3 className="font-semibold ml-6">14.00 USDT_TRC20</h3>
                        </div>

                        <div className="flex mt-4 items-center">
                            <h3 className="font-semibold min-w-[120px]">Status:</h3>
                            <p className="ml-6">PENDING</p>
                        </div>

                        {/* <div className="flex mt-4 items-center">
                            <h3 className="font-semibold min-w-[120px]">Amount Received till time:</h3>
                            <p className="ml-2">0 USDT_TRC20</p>
                        </div> */}

                        <div className="flex mt-4 items-center">
                            <h3 className="font-semibold min-w-[120px]">Order Id:</h3>
                            <p className="ml-6">9aZGuOtV-yNxZZDgh-HAL9T6OH-ukbqPraT</p>
                        </div>

                        <div className="flex mt-8">
                            <p>Thank you for your payment!</p>
                        </div>

                        <div className="flex mt-2">
                            <p>Note: If the transaction amount is less than 10 USDT, the order will fail. Please ensure your transaction meets the minimum amount requirement.</p>
                        </div>
                    </div>

            </div>

        </div>
    );
}

export default Payment;
